__turbopack_context__.v({
  "genButton": "ContributionsDescriptionInput-module-scss-module__qGIoUG__genButton",
  "header": "ContributionsDescriptionInput-module-scss-module__qGIoUG__header",
  "label": "ContributionsDescriptionInput-module-scss-module__qGIoUG__label",
  "root": "ContributionsDescriptionInput-module-scss-module__qGIoUG__root",
});
